import React from 'react';
import { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Tooltip } from 'primereact/tooltip';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import DataTable from '../../../../Components/UiComponents/DataTable';
import InputTextElement from '../../../../Components/UiComponents/InputTextElement'
import { generateMetricsReport, downloadDocs } from '../../../../Services/opportunityService';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement';
import SingleSelectElement from '../../../../Components/UiComponents/SingleSelectElement';
import { useOpportunity } from "../../../../Providers/OpportunityContext";

const Metrics = (props) => {
    const [loading, setLoading] = useState(false);
    const [newModule, setNewModule] = useState({});
    const [opportunityData, setOpportunityData] = useState({});
    const [displayValues, setDisplayValues] = useState([]);
    const [displayValues2, setDisplayValues2] = useState([]);
    const [displayValues3, setDisplayValues3] = useState([]);
    const [tooltipElem, setTooltipElem] = useState();
    const [tooltipElements, setTooltipElements] = useState();
    const [selectedOption, setSelectedOption] = useState([]);
    const [criticalheaders, setCriticalheaders] = useState([]);
    const [kpiheaders, setKpiheaders] = useState([]);
    const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
    const toastRef = useRef();

    useEffect(() => {
        if (props.fieldData.projectMetricSections) {
            let obj1 = _.find(props?.fieldData?.projectMetricSections, { section_name: "Overall Client's Desired Target Performance" })?.display_name;
            let tooltipElem = props.customerTooltipDataOthers?.metrics?.target_building_performance.status ? (
                <>
                    <Tooltip target=".custom-target-icon" />
                    <i className="custom-target-icon pi pi-info-circle tooltip-font"
                        data-pr-tooltip={props.customerTooltipDataOthers?.metrics?.target_building_performance?.text}
                        data-pr-position="right">
                    </i>
                </>
            ) : null;
            let obj2 = _.find(props?.fieldData?.projectMetricSections, { section_name: "Critical Areas" })?.display_name;
            let obj3 = _.find(props?.fieldData?.projectMetricSections, { section_name: "Building Performance" })?.display_name;
            let obj4 = _.find(props?.fieldData?.projectMetricSections, { section_name: "Project Specific KPI's & Outputs" })?.display_name;
            let obj5 = _.find(props?.fieldData?.projectMetricSections, { section_name: "Cost" })?.display_name;
            let obj6 = _.find(props?.fieldData?.projectMetricSections, { section_name: "Overall Performance Achieved above Target" })?.display_name;
            let tooltipElement1 = props.customerTooltipDataOthers?.metrics?.performance_above_target?.status ? (
                <>
                    <Tooltip target=".custom-target-icon" />
                    <i className="custom-target-icon pi pi-info-circle tooltip-font"
                        data-pr-tooltip={props.customerTooltipDataOthers?.metrics?.performance_above_target?.text}
                        data-pr-position="right">
                    </i>
                </>
            ) : null;
            let obj7 = 'Win / Loss Feedback';
            let obj8 = _.find(props?.fieldData?.projectMetricSections, { section_name: "Score Improving Factors" })?.display_name;
            let combined = { obj1, obj2, obj3, obj4, obj5, obj6, obj8 };

            // Conditionally add obj7 if props.isWonOrLoss is true
            if (props.isWonOrLoss) {
                combined.obj7 = obj7;
            }
            setNewModule(combined)
            setTooltipElem(tooltipElem)
            setTooltipElements(tooltipElement1)
        }
    }, [props.fieldData.projectMetricSections])

    useEffect(() => {
        if (props.opportunityData) {
            setOpportunityData(props.opportunityData)
        }
    }, [props.opportunityData])

    useEffect(() => {
        if (props.displayValues) {
            setDisplayValues(props.displayValues.displayValues)
            setDisplayValues2(props.displayValues.displayValues2)
            setDisplayValues3(props.displayValues.displayValues3)
        }
    }, [props.displayValues])

    useEffect(() => {
        if (props.criticalheaders) {
            setCriticalheaders(props.criticalheaders);
        }
    }, [props.criticalheaders])

    useEffect(() => {
        if (props.kpiheaders) {
            setKpiheaders(props.kpiheaders);
        }
    }, [props.kpiheaders])

    useEffect(() => {
        var updatedMetrics = opportunityData.metrics;
        if (updatedMetrics?.displayValues === undefined)
            updatedMetrics = { ...updatedMetrics, displayValues: [] }
        updatedMetrics.displayValues = displayValues;
        if (updatedMetrics?.displayValues2 === undefined)
            updatedMetrics = { ...updatedMetrics, displayValues2: [] }
        updatedMetrics.displayValues2 = displayValues2;
        if (updatedMetrics?.displayValues3 === undefined)
            updatedMetrics = { ...updatedMetrics, displayValues3: [] }
        updatedMetrics.displayValues3 = displayValues3;
        if (updatedMetrics?.critical_headers === undefined)
            updatedMetrics = { ...updatedMetrics, critical_headers: [] }
        updatedMetrics.critical_headers = criticalheaders;
        if (updatedMetrics?.kpi_headers === undefined)
            updatedMetrics = { ...updatedMetrics, kpi_headers: [] }
        updatedMetrics.kpi_headers = kpiheaders;

        setGlobalOpportunityData((prevData) => ({
            ...prevData,
            metrics: updatedMetrics,
            win_plan: opportunityData?.win_plan
        }));
    }, [opportunityData, displayValues, displayValues2, displayValues3, criticalheaders, kpiheaders]);

    const handleInputChange = (field1, field2, event) => {
        setOpportunityData((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            [field1]: {
                ...prevOpportunityDetails[field1],
                [field2]: event.target.value,
            },
        }));
    };

    const handleCheckChange = (field1, field2, value) => {
        setOpportunityData((prevOpportunityDetails) => ({
            ...prevOpportunityDetails,
            [field1]: {
                ...prevOpportunityDetails[field1],
                [field2]: value,
            },
        }));
    };

    const generateRandomID = () => {
        const hexChars = '0123456789abcdef';
        let result = '';
        for (let i = 0; i < 24; i++) {
            result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
        }
        return result;
    }

    const addItem = () => {
        const newRow = {
            _id: generateRandomID(),
            criteria: ""
        };
        setOpportunityData((prevState) => ({
            ...prevState,
            ['win_plan']: {
                ...prevState['win_plan'],
                ['client_evaluation_criteria']: [
                    ...prevState['win_plan']['client_evaluation_criteria'],
                    newRow
                ],
            },
        }));
    };

    const handleDelete = () => {
        const updatedOptions = opportunityData.win_plan?.client_evaluation_criteria.filter(
            (row) => !selectedOption.includes(row)
        );
        setOpportunityData((prevState) => ({
            ...prevState,
            win_plan: {
                ...prevState.win_plan,
                client_evaluation_criteria: updatedOptions, // Replace client_evaluation_criteria with updatedOptions
            },
        }));
        setSelectedOption([]);
    };

    const onTextChangeCriteria = (index, field) => (e) => {
        const newDocumentName = [...opportunityData?.win_plan.client_evaluation_criteria];
        if (field === "criteria") {
            newDocumentName[index][field] = e.target.value;
        } else {
            newDocumentName[index][field] = e.target.value;
        }

        setOpportunityData((prevState) => ({
            ...prevState,
            win_plan: {
                ...prevState.win_plan,
                client_evaluation_criteria: newDocumentName, // Directly set the updated array here
            },
        }));
    };

    const criteriaEditor = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className={(props.errors.includes('Client Evaluation Criteria') && row.criteria == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
                    value={row.criteria}
                    placeholder="Add New"
                    onChange={onTextChangeCriteria(index?.rowIndex, "criteria")}
                />
            </div>
        );
    };

    const columns = [
        { field: "criteria", header: _.find(props.fieldData.oppMetricsTable, { table_name: "Client Evaluation Criteria" })?.display_name, body: criteriaEditor, headerClassName: "header-datatable", className: 'row-datatable' },
    ]

    const rowClick = async (data) => {
        setSelectedOption(data)
    };

    const reorderClick = (data) => {
        setOpportunityData((prevState) => ({
            ...prevState,
            win_plan: {
                ...prevState.win_plan,
                client_evaluation_criteria: data,
            },
        }));
    }

    // const generateMetricsReports = async () => {
    //     try {
    //         const response = await generateMetricsReport(opportunityData._id, props.customerId, props.displayValues.displayValues, props.displayValues.displayValues2, props.displayValues.displayValues3, props.currency);
    //         if (response.data) {
    //             downloadDocs(response.data.fileName, token);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    const generateMetricsReports = async () => {
        try {
            setLoading(true); // Start loading spinner

            // Call API to generate metrics report
            const response = await generateMetricsReport(
                opportunityData._id,
                props.customerId,
                props.displayValues.displayValues,
                props.displayValues.displayValues2,
                props.displayValues.displayValues3,
                props.currency
            );

            // Check if the response contains data and proceed to download the document
            if (response && response.data) {
                downloadDocs(response.data.fileName);
                toastRef.current.showToast({
                    type: "success",
                    message: "Metrics report generated successfully."
                });
            } else {
                // Handle the case where there is no data in the response
                toastRef.current.showToast({
                    type: "error",
                    message: "No data received for the metrics report."
                });
            }
        } catch (error) {
            // Handle any errors that occurred during the API request
            toastRef.current.showToast({
                type: "error",
                message: "Failed to generate metrics report. Please try again or contact Admin."
            });
        } finally {
            setLoading(false);
        }
    };


    const singleSelection = (position, entities, e) => {
        const updatedEntities = entities.map((subscription, index) => {
            const updatedSubscription = { ...subscription };

            const updatedDisp = [...updatedSubscription.disp];

            if (parseInt(position) !== parseInt(index)) {
                updatedDisp[0].checked = false;
            } else {
                updatedDisp[0].checked = e.checked;
            }

            updatedSubscription.disp = updatedDisp;
            return updatedSubscription;
        });
        setDisplayValues(updatedEntities);
    }

    const handleInputChangeName = (e, index, i, field) => {
        const updatedData = [...displayValues];
        updatedData[index].disp[i][field] = e.target.value;
        setDisplayValues(updatedData);
    };

    const onChangeHeader = (index, e) => {
        const updatedData = [...criticalheaders];
        updatedData[index].header = e.target.value;
        setCriticalheaders(updatedData);
    };

    const deleteCritical = () => {
        const updatedDisplayValues = displayValues.filter(item => !item.disp[0].checked);
        setDisplayValues(updatedDisplayValues);
    }

    const addCritical = () => {
        var displayUnit = [
            { checked: false, areas: "" },
            {
                areas: "Target",
                gifa: "",
                nia: "",
                external_site: "",
                circulation1: "",
                circulation2: "",
            },
            {
                areas: "Proposed",
                gifa: "",
                nia: "",
                external_site: "",
                circulation1: "",
                circulation2: "",
            },
            {
                areas: "Build Variations",
                gifa: "",
                nia: "",
                external_site: "",
                circulation1: "",
                circulation2: "",
            },
            {
                areas: "Achieved",
                gifa: "",
                nia: "",
                external_site: "",
                circulation1: "",
                circulation2: "",
            },
        ]
        var addValue = {
            disp: JSON.parse(JSON.stringify(displayUnit)),
        }

        setDisplayValues((prevState) => [
            ...prevState,
            addValue
        ]);
    }

    const handleInputDisplay = (e, index, field) => {
        const updatedData = [...displayValues2];
        updatedData[index][field] = e.target.value;
        setDisplayValues2(updatedData);
    };

    const handleStatus = (e, index, field) => {
        const updatedData = [...displayValues2];
        updatedData[index][field] = e.target.value.label;
        setDisplayValues2(updatedData);
    }

    const singleSelectionPerformance = (position, entities, e) => {
        const updatedEntities = entities.map((subscription, index) => {
            const updatedSubscription = { ...subscription };

            if (parseInt(position) !== parseInt(index)) {
                updatedSubscription.checked = false;
            } else {
                updatedSubscription.checked = e.checked;
            }
            return updatedSubscription;
        });
        setDisplayValues2(updatedEntities);
    }

    const deletePerformance = () => {
        const updatedDisplayValues = displayValues2.filter(item => !item.checked);
        setDisplayValues2(updatedDisplayValues);
    }

    const addPerformance = () => {
        const newRow = {
            _id: generateRandomID(),
            areas: "",
            breeam: "",
            epc: "",
            leed: ""
        };
        setDisplayValues2((prevState) => [
            ...prevState,
            newRow
        ]);
    }

    const onChangeHeaderDisplay = (index, e) => {
        const updatedData = [...kpiheaders];
        updatedData[index].header = e.target.value;
        setKpiheaders(updatedData);
    };

    const singleSelectionKpi = (position, entities, e) => {
        const updatedEntities = entities.map((subscription, index) => {
            const updatedSubscription = { ...subscription };

            const updatedDisp = [...updatedSubscription.schedule];

            if (parseInt(position) !== parseInt(index)) {
                updatedDisp[0].checked = false;
            } else {
                updatedDisp[0].checked = e.checked;
            }

            updatedSubscription.disp = updatedDisp;
            return updatedSubscription;
        });
        setDisplayValues3(updatedEntities);
    }

    const handleInputChangeKpi = (e, index, i, field) => {
        const updatedData = [...displayValues3];
        updatedData[index].schedule[i][field] = e.target.value;
        setDisplayValues3(updatedData);
    };

    const handleInputChangeKpiVal = (e, index, ind, i) => {
        const updatedData = [...displayValues3];
        updatedData[index].schedule[ind].valArr[i].val = e.target.value;
        setDisplayValues3(updatedData);
    }

    const deleteKpi = () => {
        const updatedDisplayValues = displayValues3.filter(item => !item.schedule[0].checked);
        setDisplayValues3(updatedDisplayValues);
    }

    const addKpi = () => {
        var displayUnit3 = [
            { checked: false, areas: "" },
            { areas: "Current" },
            { areas: "Proposed" },
            { areas: "Achieved" },
        ]

        var iteratedHeadings = [
            { heading: "GIFA(m2)" },
            { heading: "NIA(m2)" },
            { heading: "External Site(m2)" },
            { heading: "Circulation m2" },
            { heading: "Circulation(%)" },
        ];
        var dynamicArr = [];
        for (var i = 0; i < iteratedHeadings.length; i++) {
            dynamicArr.push({ id: i, val: 0 });
        }
        for (var j = 0; j < displayUnit3.length; j++) {
            displayUnit3[j].valArr = dynamicArr;
        }

        var addValue = {
            schedule: JSON.parse(JSON.stringify(displayUnit3)),
        }

        setDisplayValues3((prevState) => [
            ...prevState,
            addValue
        ]);
    }

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            {
                <form>
                    {
                        Object.entries(newModule)?.map(([key, value]) => (
                            <div key={key} className='mt-10'>
                                <Accordion activeIndex={0}>
                                    {
                                        <AccordionTab header={(
                                            <>
                                                {(['obj1', 'obj6'].includes(key)) || value}
                                            </>
                                        )} disabled>
                                            {
                                                key == 'obj1' &&
                                                <div className='new-field position-relative'>
                                                    <div className='d-flex flex-nowrap position-absolute align-items-center' style={{top: '-3rem'}}>
                                                        <p className='fw-semibold mb-1 mr-1' style={{color: 'rgb(36, 49, 55)'}}>{value}</p> &nbsp; {tooltipElements}
                                                    </div>
                                                    <TextareaElement
                                                        name="building_performance_description"
                                                        value={opportunityData.metrics?.building_performance_description}
                                                        rows={4}
                                                        cols={30}
                                                        onChange={(e) => handleInputChange("metrics", "building_performance_description", e)}
                                                        placeholder="Enter text here..."
                                                        className="w-full"
                                                    />
                                                </div>
                                            }
                                            {
                                                key == 'obj2' &&
                                                <div className="new-field">
                                                    <div className="form-group row align-items-center mb-0">
                                                        <div className="col pr-0 d-flex justify-end delete-icon">
                                                            <ButtonElement type="button" className="edit-option-button" icon="pi pi-trash" onClick={deleteCritical} />
                                                            <ButtonElement type="button" className="edit-option-button ml-10" icon="pi pi-plus" onClick={addCritical} />
                                                        </div>
                                                    </div>
                                                    <div className="group-table-data pl-0">
                                                        <table className="group-datatable">
                                                            <thead className="group-table-header">
                                                                <tr>
                                                                    <th className="checkbox-header">&nbsp;</th>
                                                                    <th className='w-20'>&nbsp;</th>
                                                                    {
                                                                        criticalheaders && criticalheaders.length > 0 &&
                                                                        criticalheaders.map((item, index) => {
                                                                            return (
                                                                                <React.Fragment>
                                                                                    <th className='width-15'>
                                                                                        <div>
                                                                                            <InputTextElement
                                                                                                className="dropdown-field-handle"
                                                                                                value={item.header}
                                                                                                placeholder="Header"
                                                                                                onChange={(e) => onChangeHeader(index, e)}
                                                                                            />
                                                                                        </div>
                                                                                    </th>
                                                                                </React.Fragment>
                                                                            )
                                                                        })
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody className="group-table-row stakeplan">
                                                                {
                                                                    displayValues?.map((item, index) =>
                                                                        item.disp?.map((obj, i) => {
                                                                            return (
                                                                                <tr key={`${index}-${i}`}>
                                                                                    {
                                                                                        i == 0 &&
                                                                                        <td rowSpan={5}>
                                                                                            <CheckboxElement
                                                                                                id={`critical-${i}`}
                                                                                                name={`critical-${i}`}
                                                                                                checked={obj.checked || false}
                                                                                                onChangeCheck={(e) => singleSelection(index, displayValues, e)}
                                                                                                className="mr-2"
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i == 0 &&
                                                                                        <td className='w-20'>
                                                                                            <InputTextElement
                                                                                                id="areas"
                                                                                                name="areas"
                                                                                                value={obj.areas || ""}
                                                                                                onChange={(e) => handleInputChangeName(e, index, i, 'areas')}
                                                                                                required
                                                                                                placeholder="Title"
                                                                                                className={(props.errors.includes('Areas') && obj.areas == '') ? 'error-tab w-full' : 'w-full'}
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i > 0 &&
                                                                                        <td className='w-20'>
                                                                                            <InputTextElement
                                                                                                id="areas_1"
                                                                                                name="areas_1"
                                                                                                value={obj.areas || ""}
                                                                                                onChange={(e) => handleInputChangeName(e, index, i, 'areas')}
                                                                                                required
                                                                                                placeholder="Number"
                                                                                                className="w-full"
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i > 0 &&
                                                                                        <td className='width-15'>
                                                                                            <InputTextElement
                                                                                                id="gifa"
                                                                                                name="gifa"
                                                                                                value={obj.gifa || ""}
                                                                                                onChange={(e) => handleInputChangeName(e, index, i, 'gifa')}
                                                                                                required
                                                                                                placeholder="Number"
                                                                                                className="w-full"
                                                                                                type="number"
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i > 0 &&
                                                                                        <td className='width-15'>
                                                                                            <InputTextElement
                                                                                                id="nia"
                                                                                                name="nia"
                                                                                                value={obj.nia || ""}
                                                                                                onChange={(e) => handleInputChangeName(e, index, i, 'nia')}
                                                                                                required
                                                                                                placeholder="Number"
                                                                                                className="w-full"
                                                                                                type="number"
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i > 0 &&
                                                                                        <td className='width-15'>
                                                                                            <InputTextElement
                                                                                                id="external_site"
                                                                                                name="external_site"
                                                                                                value={obj.external_site || ""}
                                                                                                onChange={(e) => handleInputChangeName(e, index, i, 'external_site')}
                                                                                                required
                                                                                                placeholder="Number"
                                                                                                className="w-full"
                                                                                                type="number"
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i > 0 &&
                                                                                        <td className='width-15'>
                                                                                            <InputTextElement
                                                                                                id="circulation1"
                                                                                                name="circulation1"
                                                                                                value={obj.circulation1 || ""}
                                                                                                onChange={(e) => handleInputChangeName(e, index, i, 'circulation1')}
                                                                                                required
                                                                                                placeholder="Number"
                                                                                                className="w-full"
                                                                                                type="number"
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i > 0 &&
                                                                                        <td className='width-15'>
                                                                                            <InputTextElement
                                                                                                id="circulation2"
                                                                                                name="circulation2"
                                                                                                value={obj.circulation2 || ""}
                                                                                                onChange={(e) => handleInputChangeName(e, index, i, 'circulation2')}
                                                                                                required
                                                                                                placeholder="Number"
                                                                                                className="w-full"
                                                                                                type="number"
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                key == 'obj3' &&
                                                <div>
                                                    {
                                                        _.find(props.fieldData.oppMetricsTable, { table_name: "Building Performance" })?.status &&
                                                        <div className="new-field">
                                                            <div className="form-group row align-items-center mb-0">
                                                                <div className="col pr-0 d-flex justify-end delete-icon">
                                                                    <ButtonElement type="button" className="edit-option-button" icon="pi pi-trash" onClick={deletePerformance} />
                                                                    <ButtonElement type="button" className="edit-option-button ml-10" icon="pi pi-plus" onClick={addPerformance} />
                                                                </div>
                                                            </div>
                                                            <div className="group-table-data pl-0">
                                                                <table className="group-datatable">
                                                                    <thead className="group-table-header">
                                                                        <tr>
                                                                            <th className="checkbox-header">&nbsp;</th>
                                                                            <th className='w-20'>&nbsp;</th>
                                                                            <th className='w-20'>{_.find(props.fieldData.oppMetricsHeaders, { header_name: 'BREEAM' })?.display_name}</th>
                                                                            <th className='w-20'>{_.find(props.fieldData.oppMetricsHeaders, { header_name: 'EPC' })?.display_name}</th>
                                                                            <th className='w-20'>{_.find(props.fieldData.oppMetricsHeaders, { header_name: 'LEED' })?.display_name}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="group-table-row stakeplan">
                                                                        {
                                                                            displayValues2?.map((obj, i) => {
                                                                                const breeam_list = obj.breeam;

                                                                                const matched = props.breeamOptions.find(
                                                                                    (item) => item.label === breeam_list
                                                                                );
                                                                                return (
                                                                                    <tr key={`${i}`}>
                                                                                        {
                                                                                            i > 1 ?
                                                                                                <td>
                                                                                                    <CheckboxElement
                                                                                                        id={`performance-${i}`}
                                                                                                        name={`performance-${i}`}
                                                                                                        checked={obj.checked || false}
                                                                                                        onChangeCheck={(e) => singleSelectionPerformance(i, displayValues2, e)}
                                                                                                        className="mr-2"
                                                                                                    />
                                                                                                </td> :
                                                                                                <td>&nbsp;</td>
                                                                                        }
                                                                                        {
                                                                                            i == 0 &&
                                                                                            <td className='w-20'>
                                                                                                <span className='form-label text-left'>{obj.areas}</span>
                                                                                            </td>
                                                                                        }
                                                                                        {
                                                                                            i == 1 &&
                                                                                            <td className='w-20'>
                                                                                                <span className='form-label text-left'>{obj.areas}</span>
                                                                                            </td>
                                                                                        }
                                                                                        {
                                                                                            i > 1 &&
                                                                                            <td className='w-20'>
                                                                                                <InputTextElement
                                                                                                    id="building_performance_title"
                                                                                                    name="building_performance_title"
                                                                                                    value={obj.areas || ""}
                                                                                                    onChange={(e) => handleInputDisplay(e, i, 'areas')}
                                                                                                    required
                                                                                                    placeholder="Text"
                                                                                                    className={(props.errors.includes('Building Performance Title') && obj.areas == '') ? 'error-tab w-full' : 'w-full'}
                                                                                                />
                                                                                            </td>
                                                                                        }
                                                                                        {
                                                                                            <td className='w-20'>
                                                                                                <SingleSelectElement
                                                                                                    id='breeam'
                                                                                                    name="breeam"
                                                                                                    options={(props.breeamOptions != undefined && props.breeamOptions.length > 0) ? props.breeamOptions : []}
                                                                                                    optionLabel="label"
                                                                                                    value={matched ? matched : null}
                                                                                                    onChangeValue={(e) => handleStatus(e, i, 'breeam')}
                                                                                                    placeholder="-- Please select --"
                                                                                                    maxSelectedLabels={1}
                                                                                                    className="w-full"
                                                                                                />
                                                                                            </td>
                                                                                        }
                                                                                        {
                                                                                            <td className='w-20'>
                                                                                                <InputTextElement
                                                                                                    id="epc"
                                                                                                    name="epc"
                                                                                                    value={obj.epc || ""}
                                                                                                    onChange={(e) => handleInputDisplay(e, i, 'epc')}
                                                                                                    required
                                                                                                    placeholder="Number"
                                                                                                    className="w-full"
                                                                                                    type="number"
                                                                                                />
                                                                                            </td>
                                                                                        }
                                                                                        {
                                                                                            <td className='w-20'>
                                                                                                <InputTextElement
                                                                                                    id="leed"
                                                                                                    name="leed"
                                                                                                    value={obj.leed || ""}
                                                                                                    onChange={(e) => handleInputDisplay(e, i, 'leed')}
                                                                                                    required
                                                                                                    placeholder="Text"
                                                                                                    className="w-full"
                                                                                                />
                                                                                            </td>
                                                                                        }
                                                                                    </tr>
                                                                                );
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                key == 'obj4' &&
                                                <div className='new-field kpi-output'>
                                                    <div className="form-group row align-items-center mb-0">
                                                        <div className="col pr-0 d-flex justify-end delete-icon">
                                                            <ButtonElement type="button" className="edit-option-button" icon="pi pi-trash" onClick={deleteKpi} />
                                                            <ButtonElement type="button" className="edit-option-button ml-10" icon="pi pi-plus" onClick={addKpi} />
                                                        </div>
                                                    </div>
                                                    <div className="group-table-data pl-0">
                                                        <table className="group-datatable">
                                                            <thead className="group-table-header">
                                                                <tr>
                                                                    <th className="checkbox-header">&nbsp;</th>
                                                                    <th className='w-20'>&nbsp;</th>
                                                                    {
                                                                        kpiheaders && kpiheaders.length > 0 &&
                                                                        kpiheaders.map((item, index) => {
                                                                            return (
                                                                                <React.Fragment>
                                                                                    <th className='width-15'>
                                                                                        <div>
                                                                                            <InputTextElement
                                                                                                className="dropdown-field-handle"
                                                                                                value={item.header}
                                                                                                placeholder="Header"
                                                                                                onChange={(e) => onChangeHeaderDisplay(index, e)}
                                                                                            />
                                                                                        </div>
                                                                                    </th>
                                                                                </React.Fragment>
                                                                            )
                                                                        })
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody className="group-table-row stakeplan">
                                                                {
                                                                    displayValues3?.map((item, index) =>
                                                                        item.schedule?.map((obj, i) => {
                                                                            return (
                                                                                <tr key={`${index}-${i}`}>
                                                                                    {
                                                                                        i == 0 &&
                                                                                        <td rowSpan={4}>
                                                                                            <CheckboxElement
                                                                                                id={`kpi-${i}`}
                                                                                                name={`kpi-${i}`}
                                                                                                checked={obj.checked || false}
                                                                                                onChangeCheck={(e) => singleSelectionKpi(index, displayValues3, e)}
                                                                                                className="mr-2"
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i == 0 &&
                                                                                        <td className='w-20'>
                                                                                            <InputTextElement
                                                                                                id="areas"
                                                                                                name="areas"
                                                                                                value={obj.areas || ""}
                                                                                                onChange={(e) => handleInputChangeKpi(e, index, i, 'areas')}
                                                                                                required
                                                                                                placeholder="Title"
                                                                                                className={(props.errors.includes('Accomdations Title') && obj.areas == '') ? 'error-tab w-full' : 'w-full'}
                                                                                            />
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i > 0 &&
                                                                                        <td className='w-20'>
                                                                                            <span className='form-label text-left'>{obj.areas}</span>
                                                                                        </td>
                                                                                    }
                                                                                    {
                                                                                        i > 0 &&
                                                                                        obj.valArr?.map((value, ind) => (
                                                                                            <td key={ind} className='width-15'>
                                                                                                <InputTextElement
                                                                                                    id={`accomm-${ind}`}
                                                                                                    name={`accomm-${ind}`}
                                                                                                    value={value.val || ""}
                                                                                                    onChange={(e) => handleInputChangeKpiVal(e, index, i, ind)}
                                                                                                    required
                                                                                                    placeholder="Number"
                                                                                                    className="w-full"
                                                                                                    type="number"
                                                                                                />
                                                                                            </td>
                                                                                        ))
                                                                                    }
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                key == 'obj5' &&
                                                <div className="new-field d-flex">
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "BCIS" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "BCIS" })?.display_name + ' (' + (props.currency + '/m2)')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="bcis"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.bcis}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "bcis", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "BCIS min" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "BCIS min" })?.display_name + ' (' + (props.currency + '/m2)')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="bcis_min"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.bcis_min}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "bcis_min", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "BCIS max" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "BCIS max" })?.display_name + ' (' + (props.currency + '/m2)')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="bcis_max"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.bcis_max}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "bcis_max", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "BCIS avg" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "BCIS avg" })?.display_name + ' (' + (props.currency + '/m2)')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="bcis_av"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.bcis_av}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "bcis_av", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Budget" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Budget" })?.display_name + ' (' + (props.currency + '/m2)')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="budget"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.budget}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "budget", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Proposed / Price" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Proposed / Price" })?.display_name + ' (' + (props.currency + '/m2)')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="proposed"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.proposed}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "proposed", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Price / Unit" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Price / Unit" })?.display_name}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="price_unit"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.price_unit}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "price_unit", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Qty M2" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Qty M2" })?.display_name}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="qty_m2"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.qty_m2}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "qty_m2", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Price" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Price" })?.display_name + ' (' + (props.currency + '/m2)')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="price"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.price}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "price", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Cost / Unit" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Cost / Unit" })?.display_name}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="cost_unit"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.cost_unit}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "cost_unit", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Cost" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Cost" })?.display_name + ' (' + (props.currency + '/m2) / Item')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="cost_item"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.cost_item}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "cost_item", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Gross Development Value" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Gross Development Value" })?.display_name}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="gross_1"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.gross_1}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "gross_1", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Gross Development Unit Value" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Gross Development Unit Value" })?.display_name}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="gross_2"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.gross_2}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "gross_2", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Gross Development" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Gross Development" })?.display_name + ' (' + (props.currency + '/m2)')}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="gross_3"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.gross_3}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "gross_3", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Development Build" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Development Build" })?.display_name + ' %'}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="development_build"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.development_build}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "development_build", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.fieldData.projectMetricFields, { field_name: "Qty Units" })?.field_status &&
                                                            <div className="form-group row mb-0 mt-0">
                                                                <div className="col pr-0">
                                                                    <div className="form-group row align-items-center mb-0">
                                                                        <div className="col-md-4 pl-0">
                                                                            <label className="form-label text-left">{_.find(props.fieldData.projectMetricFields, { field_name: "Qty Units" })?.display_name}:</label>
                                                                        </div>
                                                                        <div className="col pr-0">
                                                                            <InputTextElement
                                                                                name="qty_units"
                                                                                className="dropdown-field-handle"
                                                                                value={opportunityData.metrics?.qty_units}
                                                                                placeholder="Number"
                                                                                onChange={(e) => handleInputChange("metrics", "qty_units", e)}
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                type="number"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            {
                                                key == 'obj6' &&
                                                <div className="new-field position-relative">
                                                    <div className='d-flex flex-nowrap  position-absolute align-items-center' style={{top: '-3.2rem'}}>
                                                        <p className='fw-semibold mb-1 mr-1' style={{color: 'rgb(36, 49, 55)'}}>{value}</p> &nbsp; {tooltipElem}
                                                    </div>
                                                    <TextareaElement
                                                        name="benefits_of_our_offer"
                                                        value={opportunityData.metrics?.benefits_of_our_offer}
                                                        onChange={(e) => handleInputChange("metrics", "benefits_of_our_offer", e)}
                                                        rows={4}
                                                        cols={30}
                                                        placeholder="Enter text here..."
                                                        className="w-full"
                                                    />
                                                </div>
                                            }
                                            {
                                                key == 'obj7' &&
                                                <div className="new-field">
                                                    <TextareaElement
                                                        name="win_loss_feedback"
                                                        value={opportunityData.metrics?.win_loss_feedback}
                                                        onChange={(e) => handleInputChange("metrics", "win_loss_feedback", e)}
                                                        rows={4}
                                                        cols={30}
                                                        placeholder="Enter text here..."
                                                        className="w-full"
                                                    />
                                                </div>
                                            }
                                            {
                                                key == 'obj8' &&
                                                <div className="new-field">
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-4 pl-0">
                                                            <label className="form-label text-left">Do we have evaluation scoring criteria?</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <RadioElement
                                                                id="evaluation_scoring_criteria"
                                                                options={[{ key: "yes", name: "Yes", value: "yes" }, { key: "no", name: "No", value: "no" }]}
                                                                value={opportunityData.win_plan?.evaluation_scoring_criteria}
                                                                onChangeRadio={(value) => {
                                                                    handleCheckChange("win_plan", "evaluation_scoring_criteria", value);
                                                                }}
                                                                className="radio-group-class"
                                                            />
                                                        </div>
                                                    </div>
                                                    {
                                                        _.find(props.fieldData.oppMetricsTable, { table_name: "Client Evaluation Criteria" })?.status &&
                                                        <div className="form-group row mb-0 mt-0">
                                                            <div className="col pr-0">
                                                                <div className="form-group row align-items-center mb-0">
                                                                    <div className="col pr-0 d-flex justify-end">
                                                                        <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDelete} />
                                                                        <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItem} />
                                                                    </div>
                                                                </div>
                                                                <DataTable
                                                                    value={opportunityData.win_plan?.client_evaluation_criteria.length > 0 ? opportunityData.win_plan?.client_evaluation_criteria : []}
                                                                    columns={columns}
                                                                    dataKey="_id"
                                                                    isCheckbox={true}
                                                                    rowClick={rowClick}
                                                                    reorderClick={reorderClick}
                                                                />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </AccordionTab>
                                    }
                                </Accordion>
                            </div>
                        )
                        )
                    }
                </form>
            }
            <div className="cancel-footer mt-20">
                <div className='d-flex align-center justify-end pb-0'>
                    <ButtonElement className="save-button" type="submit" label={`Generate ${props.fieldData.pipelineClientsubmodule} Report`} onClick={generateMetricsReports} />
                </div>
            </div>
        </div>
    )
}

export default Metrics